import { get } from "lodash";

const ApiConstant: any = {
    getOperationSummary: "/Sites/GetOperationSummaryDetails",
    getRoutesSummary: "/Route",
    getOperationDetailsDates: "/OperationDetails/GetLeakDateList/",
    getToken: "/api/token",
    getAllCustomerList: "/api/customer/getallcustomers",
    getUser: "/api/auth/getuser",
    addOrUpdateAogiSite: "/api/assets/uploadaogisites",
    getSurveyDetails: "/api/assets/GetAOGISurveyDetails",
    addOrUpdateSurveyDetails: "/api/assets/UpdateSurveyEmission",
    addOrUpdateSurveyDetailsNew: "/api/assets/UpdateSurveyEmissionNew",
    dowloadFiles: "/api/assets/DownloadBlobByID",
    removeSiteDetails: "/api/assets/RemoveAOGISurveySites",
    removeEmissionDetails: "/api/assets/RemoveSurveyEmission",
    getAogiSites: "/api/assets/getaogisites",
    removeAogiSite: "/api/assets/removeaogisite",
    addSurvey: "/api/assets/createaogisurvey",
    getAOGISurveys: "/api/assets/getaogisurveys",
    updateAogiSurvey: "/api/assets/updateaogisurvey",
    removeAogiSurvey: "/api/assets/removeaogisurvey",
    GetAOGIAllSurveyDetails: "/api/assets/GetAOGIAllSurveyDetails",
    getPermissionsOfCurrentUser: "api/auth/getUserPermissions",
    GetBlobURI: "/api/assets/GetBlobURI",
    SiteSummary: "/api/sites/",
    postUpdateSiteSummary: "/api/Sites/UpdateSite/",
    addSiteSummary: "/api/Sites/CreateSite/",
    getAllCustomers: "/api/Customers/",
    getOperationDetails: "/api/OperationDetails/OperationLeakDetails/",
    getRouteBySite:"/api/Route/GetRouteDetailsForSite/",
    getCameraOperators:"/api/CameraOperator",
    getbyCameraOperatorId:"/api/CameraOperator/GetbyOperatorId/",
    UpdateCameraOperator:"/api/CameraOperator/UpdateOperator/",
    deleteCameraOperator:"/api/CameraOperator/DeleteOperator/",
    getSites:"/api/v1/Sites/GetSites",
    downloadKMLSites:"/api/v1/Sites/DownloadKMLSites",
    getOverviewSites:"/api/v1/Sites/GetInspectionOverviewSites",
    pinnedandUnpinned: "/api/v1/Sites/PinOrUnpinFavoriteSites",
    klvJosnLocaton: "/api/v1/Sites/KlvJosnLocaton",
    getSurveyInformation: "/api/v1/Survey/GetSurveyInformation",
    getSurveyOverview: "/api/v1/Survey/GetSurveyOverview",
    getmediaData: "/api/v1/Survey/GetFileFromAzure",
    getUserSettings :"/api//Emission/GetUserSettings",
    downloadJsonSite: "/api/v1/Survey/DownloadSurveyDetailsAsJson",
    downloadQuickSurveyReport: "/api/v1/SurveyReport/DownloadQuickSurveyReport",
    getRoutes: "/api/v1/Route/GetRoutes",
    getSurveyHistory: "/api/v1/Sites/GetSurveyHistory",
    getSiteSummary: "/api/Sites",
    getCameraOperator: "/api/CameraOperator",
    getSitesByCustomerId: "/api/v1/Sites/GetSitesByCustomerId",
    getSiteDetails: "/api/v1/Sites/GetSites",
    createSite: "/api/v1/Sites/CreateSite",
    updateSite: "/api/v1/Sites/UpdateSite/",
    getVoluntarySurveySites: "/api/v1/Sites/GetVoluntarySurveySites",
    getVoluntarySurveyOverview: "/api/v1/Survey/GetVoluntarySurveyOverview",
    getVoluntarySurveyInformation: "/api/v1/Survey/GetVoluntarySurveyInformation",
    getVoluntarySurveyHistory: "/api/v1/Sites/GetVoluntarySurveyHistory",
    getVoluntarySurveySitesByCustomerId: "/api/v1/Sites/GetSitesByCustomerId",
    downloadVoluntarySurveyDetails: "/api/v1/Survey/DownloadVoluntarySurveyDetails",
    getConnexiaSites:"/api/v1/Sites/GetConnexiaSites",
    getCustomers:"/api/v1/Customers/GetCustomers",    
    getCustomerById:"/api/v1/Customers/GetCustomerById",
    getConnexiaSiteById:"/api/v1/Sites/GetConnexiaSiteById",
    getGeneralOverview:"/api/v1/Survey/GetGeneralOverview",
    getLeakAnalytics:"/api/v1/Survey/GetLeakAnalytics",
    getLeakTrends:"/api/v1/Survey/GetLeakTrends",
    uploadRouteFloorPlan: "/api/v1/Route/UploadRouteFloorPlan",
    getRouteFloorPlan: "/api/v1/Route/GetRouteFloorPlan",
    updateLeakeStatus: "api/v1/Survey/UpdateLeakStatus",
};

export default ApiConstant;
